import { AcademicInstitutions } from './AcademicInstitutions'
import AccordionSection from './AccordionSection'
import BannerWithArticle from './BannerWithArticle'
import { BannerWithText } from './BannerWithText'
import BasicArticle from './BasicArticle'
import BasicTextSection from './BasicTextSection'
import { BlockMenu } from './block-menu/BlockMenu'
import { BlockMenuAdditionalShortcuts } from './block-menu/BlockMenuAdditionalShortcuts'
import { BlockMenuCta } from './block-menu-cta/BlockMenuCta'
import { ButtonBlockSection } from './ButtonBlockSection'
import CarouselSection from './CarouselSection'
import { ComponentNotFound } from './ComponentNotFound'
import { CtaBlockSection } from './CtaBlockSection'
import { CtaCardSection } from './CtaCardSection'
import DFHStoryDispensary from './DFHStoryDispensary'
import { DisclaimerModule } from './DisclaimerModule'
import DispensaryAbout from './DispensaryAbout'
import DispensaryBanner from './DispensaryBanner'
import DispensaryBio from './DispensaryBio'
import DispensaryFeaturedProducts from './DispensaryFeaturedProducts'
import { EduModule } from './EduModule'
import FAQ from './FAQ'
import FeaturedProductsBanner from './FeaturedProductsBanner'
import FeaturedProductsCarousel from './FeaturedProductsCarousel'
import GlobalMarkets from './GlobalMarkets'
import HubSpotForm from './HubSpotForm'
import { IconAndTextGrid } from './IconAndTextGrid'
import { IconAndTextGridSmall } from './IconAndTextGridSmall'
import ImageAndTextSection from './ImageAndTextSection'
import Instapage from './Instapage'
import { LeadershipGrid } from './LeadershipGrid'
import Library from './library/Library'
import LogoDividerSection from './LogoDividerSection'
import { Notification } from './Notification'
import PageHero from './PageHero'
import PageHeroSecondary from './PageHeroSecondary'
import ProductDescription from './ProductDescription'
import { ProductSpotlight } from './ProductSpotlight'
import RichArticle from './RichArticle'
import SanityBanner from './SanityBanner'
import SanityContentBlockCopySectionCentered from './SanityContentBlock/SanityContentBlockCopySectionCentered'
import SanityContentBlockGlobalNetwork from './SanityContentBlock/SanityContentBlockGlobalNetwork'
import SanityContentBlockHeroProduct from './SanityContentBlock/SanityContentBlockHeroProduct'
import SanityContentBlockImageBreaker from './SanityContentBlock/SanityContentBlockImageBreaker'
import SanityContentBlockIntroCopyCentered from './SanityContentBlock/SanityContentBlockIntroCopyCentered'
import SanityContentBlockWithImage from './SanityContentBlock/SanityContentBlockWithImage'
import HeroBanner from './SanityHero'
import { ScienceTeamGrid } from './ScienceTeamGrid'
import SpacerSection from './SpacerSection'
import TableSection from './TableSection'
import { TabsCarousel } from './TabsCarousel'
import { TermsSection } from './TermsSection'
import TopBanner from './TopBanner'
import VideoSection from './VideoSection'
import VirtualDispensary from './VirtualDispensary'

const ComponentList = {
  bannerWithArticle: BannerWithArticle,
  bannerWithText: BannerWithText,
  basicArticle: BasicArticle,
  basicTextSection: BasicTextSection,
  blockMenu: BlockMenu,
  blockMenuCta: BlockMenuCta,
  blockMenuAdditionalShortcuts: BlockMenuAdditionalShortcuts,
  buttonBlockSection: ButtonBlockSection,
  carouselSection: CarouselSection,
  ctaBlockSection: CtaBlockSection,
  ctaCardSection: CtaCardSection,
  dispensaryBio: DispensaryBio,
  dispensaryFeaturedProducts: DispensaryFeaturedProducts,
  featuredProductsBanner: FeaturedProductsBanner,
  featuredProductsCarousel: FeaturedProductsCarousel,
  globalMarkets: GlobalMarkets,
  hubSpotForm: HubSpotForm,
  iconAndTextGrid: IconAndTextGrid,
  iconAndTextGridSmall: IconAndTextGridSmall,
  imageAndTextSection: ImageAndTextSection,
  instapage: Instapage,
  leadershipGrid: LeadershipGrid,
  library: Library,
  logoDividerSection: LogoDividerSection,
  notification: Notification,
  pageHero: PageHero,
  pageHeroSecondary: PageHeroSecondary,
  productDescription: ProductDescription,
  productSpotlight: ProductSpotlight,
  richArticle: RichArticle,
  scienceTeamGrid: ScienceTeamGrid,
  spacerSection: SpacerSection,
  styleIconAndTextGrid: IconAndTextGrid,
  accordionSection: AccordionSection,
  tabsCarousel: TabsCarousel,
  tableSection: TableSection,
  termsSection: TermsSection,
  videoSection: VideoSection,
  contentBlockWithImage: SanityContentBlockWithImage,
  contentBlockGlobalNetwork: SanityContentBlockGlobalNetwork,
  contentBlockIntroCopyCentered: SanityContentBlockIntroCopyCentered,
  contentBlockCopySectionCentered: SanityContentBlockCopySectionCentered,
  contentBlockImageBreaker: SanityContentBlockImageBreaker,
  contentBlockHeroProduct: SanityContentBlockHeroProduct,
  banner: SanityBanner,
  hero: HeroBanner,
  academicInstitutions: AcademicInstitutions,
  eduModule: EduModule,
  disclaimerModule: DisclaimerModule,
  virtualDispensary: VirtualDispensary,
  dfhStoryDispensary: DFHStoryDispensary,
  dispensaryAbout: DispensaryAbout,
  dispensaryBanner: DispensaryBanner,
  faq: FAQ,
  topBannerSection: TopBanner,
}

const SanityPageComponents = (type) => {
  if (typeof ComponentList[type] === 'undefined') {
    return ComponentNotFound(type)
  }
  return ComponentList[type]
}

export default SanityPageComponents
